import merge from 'lodash/merge'
import type {ThemeBuiltType} from './ThemeType'

const compile = (
    theme: ThemeBuiltType,
    componentParameters: { [key: string]: unknown },
    styleFields: Array<string>
) => {
    let compiledTheme: ThemeBuiltType = {}

    for (const [key, value] of Object.entries(theme)) {
        if (styleFields.includes(key)) {

            compiledTheme = merge(
                {},
                compiledTheme,
                {
                    [key]: value
                }
            )

            continue
        }

        /* key-value combination */

        const keys = key.match(/(.*)_(.*)/)

        if (!keys) {
            continue
        }

        const key1 = keys[1]
        const key2 = keys[2]

        const value2 = componentParameters[key2]

        if (
            /**
             * i.e.:
             * {
             *     intent={'primary highlight'}
             * }
             */
            (
                typeof value2 === 'string'
                && value2.split(' ').includes(key1)
            )
            ||
            /**
             * i.e:
             * {
             *     disabled={true}
             * }
             */
            (
                typeof value2 === 'boolean'
                && value2
            )
            ||
            /*
            * i.e:
            * {
            *     onClick={() => {
            *         //
            *     }}
            * }
            */
            (
                typeof value2 === 'function'
            )
        ) {
            const internal = compile(
                value as ThemeBuiltType,
                componentParameters,
                styleFields
            )

            compiledTheme = merge(
                {},
                compiledTheme,
                internal
            )
        }
    }

    return compiledTheme
}

export {
    compile
}
